"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var USE_CLASSES = {
  default: '',
  dark: 'private-tool-bar--dark',
  'filter-bar': 'private-tool-bar--with-filters',
  tabs: 'private-tool-bar--with-tabs'
};

var _default = _react.default.createClass({
  displayName: "UIToolBar",
  propTypes: {
    children: _react.PropTypes.node,
    title: _react.PropTypes.string,
    use: _react.PropTypes.oneOf(Object.keys(USE_CLASSES))
  },
  getClassName: function getClassName(_ref) {
    var className = _ref.className,
        use = _ref.use;
    return (0, _classNames.default)('private-tool-bar', className, USE_CLASSES[use]);
  },
  render: function render() {
    // `title` blacklisted here since `UIAbstractPageTemplate` expects one in CustomRenderer
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        __title = _this$props.title,
        use = _this$props.use,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["children", "className", "title", "use"]);

    var childCount = _react.Children.count(children);

    if (use === 'filter-bar' && childCount > 2) {
      _devLogger.default.warn({
        message: 'UIToolBar: More than 2 UIToolBarGroup items in a filter-bar is not recommended',
        key: 'UIToolBar: too many children for filter-bar'
      });
    }

    if (childCount > 3) {
      _devLogger.default.warn({
        message: 'UIToolBar: More than 3 UIToolBarGroup items are not recommended',
        key: 'UIToolBar: too many children in toolbar'
      });
    }

    return _react.default.createElement("div", (0, _extends2.default)({}, rest, {
      className: this.getClassName({
        className: className,
        use: use
      }),
      role: "group"
    }), _react.default.createElement("div", {
      className: "private-tool-bar__inner"
    }, children));
  }
});

exports.default = _default;
module.exports = exports.default;